import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Output, Renderer2, signal } from '@angular/core';
import { CommonModule, KeyValue } from '@angular/common';
import '@maersk-global/mds-components-core-top-bar';
import '@maersk-global/mds-components-core-button';
import '@maersk-global/mds-components-core-icon';
import '@maersk-global/mds-components-core-tooltip';
import '@maersk-global/mds-components-core-drawer';
import '@maersk-global/mds-components-core-loading-indicator';
import { Theme } from '../../theme/theme';
import { ThemeService } from '../../theme/theme.service';
import { AuthHelper } from '../../auth/auth-helper';
import { NotificationService } from '../../services/notification.service';
import { groupBy } from 'lodash-es';
import { NotificationItem } from '../../models/notification-item.model';
import { NotificationItemComponent } from '../notification-item/notification-item.component';
import { firstValueFrom } from 'rxjs';
import { ApprovalWoService } from '../../services/approval-wo.service';
@Component({
  selector: 'top-bar',
  imports: [CommonModule, NotificationItemComponent],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarComponent {
  @Output() menuClicked = new EventEmitter();
  openNotification = signal(false);
  currentTheme: Theme = Theme.LIGHT; // Set the default theme to light
  isSideNavOpen = false;
  loggedInUser = AuthHelper.user;
  notificationItems: Record<string, NotificationItem[]> | undefined;
  constructor(
    private themeService: ThemeService,
    private renderer: Renderer2,
    public notificationService: NotificationService,
    private approvalWOService: ApprovalWoService,
  ) {
    this.themeService.setTheme(this.currentTheme, this.renderer);
    notificationService.checkLongrunningJobsForLoggedinUser();
    notificationService.Notifications.subscribe((x) => {
      x.sort((a, b) => b.associatedTaskCreatedAt.getTime() - a.associatedTaskCreatedAt.getTime());
      this.notificationItems = groupBy(x, (x) => x.daysBefore);
    });
  }

  onToggleThemeClicked() {
    this.currentTheme = this.currentTheme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT;
    this.themeService.setTheme(this.currentTheme, this.renderer);
  }
  async onLogoutClicked() {
    try {
      await this.unassignWorkOrderOnLogout();
    } catch (error) {}
    AuthHelper.logout();
  }
  async unassignWorkOrderOnLogout() {
    let req = {
      workOrderId: 0,
      actionType: 'LogOut',
      maintenanceOrderRemarks: [],
    };
    await firstValueFrom(this.approvalWOService.unassignOnLogout(req));
  }
  onHamburgerClicked() {
    this.isSideNavOpen = !this.isSideNavOpen;
    this.menuClicked.emit();
  }
  onNotificationClosed() {
    this.openNotification.set(false);
  }
  onBellIconClicked() {
    this.openNotification.set(true);
    this.notificationService.NewNotificationsCount = 0;
    localStorage.setItem('inProgressOrQueuedCreateJobs', this.notificationService.InProgressJobsCount.toString());
  }
  numericCompare(a: KeyValue<string, any>, b: KeyValue<string, any>): number {
    return parseInt(a.key, 10) - parseInt(b.key, 10);
  }
}
